import * as React from "react";
import { connect } from "react-redux";

import { AppShape } from "@eave/shared/types/api";
import { setLoanAppContextForMaskingLogs } from "web_modules/utils/sentry";
import { loadEvents, EventsState } from "web_modules/Events/redux";
import { loadApp } from "../actions";

import Events from "./Events";

const styles = require("./styles.module.scss");

interface Props {
  appId: number;
  app: AppShape;
  events: EventsState;
  loadApp: Function;
  loadEvents: (id: number) => void;
}

class NotesScreen extends React.Component<Props, {}> {
  componentDidMount() {
    const { appId, app, loadApp, loadEvents } = this.props;

    // Refresh events to pull any new ones since app loaded
    loadEvents(appId);

    if (app) {
      setLoanAppContextForMaskingLogs(app);
    } else {
      loadApp(appId);
    }
  }

  componentDidUpdate(prevProps) {
    const { appId, app, loadEvents } = this.props;

    if (appId !== prevProps.appId) {
      loadEvents(appId);
    }
    if (app) {
      setLoanAppContextForMaskingLogs(app);
    }
  }

  render() {
    const { appId, app, events } = this.props;

    if (!app) {
      return null;
    }

    return (
      <div className={styles.screen}>
        <h3>Notes & Events (most recent first)</h3>
        <Events appId={appId} events={events} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { loanApps } = state.operator;
  const { events } = state;
  const { appId } = ownProps.match.params;

  const id = appId ? parseInt(appId, 10) : null;
  const app = loanApps ? loanApps.find((app: AppShape) => app.id === id) : null;

  return {
    appId,
    app,
    events,
  };
};

const mapDispatchToProps = dispatch => ({
  loadApp: id => loadApp(dispatch, id),
  loadEvents: id => dispatch(loadEvents(id)),
});

export default connect<any, any>(mapStateToProps, mapDispatchToProps)(NotesScreen);
